import _BRANCH from "../_BRANCH";

const LOCAL_DEV: boolean = _BRANCH === "dev" && __DEV__;
export default LOCAL_DEV;
